import React, { useState } from 'react';
import { Check, X } from 'lucide-react';
import './Pricing.css';
import { Link } from 'react-scroll';

const Pricing = () => {
  // Estado para controlar si vemos precios mensuales o anuales
  const [isAnnual, setIsAnnual] = useState(false);

  const plans = [
    {
      name: 'Básico',
      monthlyPrice: '$3.99',
      annualPrice: '$3.39', // 15% de descuento aprox
      period: 'por vehículo / mes',
      description: 'Ideal para pequeñas flotas que necesitan control y telemetría esencial.',
      features: [
        { text: 'Rastreo en tiempo real', included: true },
        { text: 'Historial de rutas (30 días)', included: true },
        { text: 'Odómetro Virtual', included: true },
        { text: 'App Móvil y Geocercas (5)', included: true },
        { text: 'Alertas por Voz (TTS)', included: false },
        { text: 'Semáforo de Vencimientos', included: false },
        { text: 'Auditoría Eco-Driving', included: false },
        { text: 'Comandos Remotos (OTA)', included: false },
        { text: 'Soporte 24/7', included: false },
      ],
      cta: 'Comenzar Ahora',
      popular: false
    },
    {
      name: 'Profesional',
      monthlyPrice: '$6.99',
      annualPrice: '$5.89', // 15% de descuento aprox
      period: 'por vehículo / mes',
      description: 'Perfecto para empresas que requieren prevención de riesgos e inteligencia telemática.',
      features: [
        { text: 'Rastreo en tiempo real', included: true },
        { text: 'Historial de rutas (90 días)', included: true },
        { text: 'Odómetro Virtual', included: true },
        { text: 'Geocercas ilimitadas', included: true },
        { text: 'Alertas por Voz (TTS)', included: true },
        { text: 'Semáforo de Vencimientos', included: true },
        { text: 'Auditoría Eco-Driving', included: true },
        { text: 'Comandos Remotos (OTA)', included: false },
        { text: 'Soporte 24/7', included: false },
      ],
      cta: 'Elegir Plan',
      popular: true
    },
    {
      name: 'Empresarial',
      monthlyPrice: 'Contactar',
      annualPrice: 'Contactar',
      period: 'solución a medida',
      description: 'El ecosistema completo para operaciones tácticas y flotas corporativas grandes.',
      features: [
        { text: 'Rastreo en tiempo real', included: true },
        { text: 'Historial forense (Ilimitado)', included: true },
        { text: 'Odómetro Virtual', included: true },
        { text: 'Geocercas ilimitadas', included: true },
        { text: 'Alertas por Voz (TTS)', included: true },
        { text: 'Semáforo de Vencimientos', included: true },
        { text: 'Auditoría Eco-Driving', included: true },
        { text: 'Comandos Remotos (OTA)', included: true },
        { text: 'Soporte 24/7 y API', included: true },
      ],
      cta: 'Contactar Ventas',
      popular: false
    }
  ];

  return (
    <section id="pricing" className="section section-alt">
      <div className="container">
        <h2 className="section-title">Planes y Precios</h2>
        <p className="section-subtitle">
          Ofrecemos planes flexibles que se adaptan a las necesidades de tu negocio, 
          desde pequeñas flotas hasta operaciones corporativas.
        </p>

        {/* CONTROLES DEL TOGGLE INTERACTIVO */}
        <div className="pricing-toggle">
          <span 
            className={`pricing-toggle-option ${!isAnnual ? 'active' : ''}`}
            onClick={() => setIsAnnual(false)}
          >
            Facturación Mensual
          </span>
          <span 
            className={`pricing-toggle-option ${isAnnual ? 'active' : ''}`}
            onClick={() => setIsAnnual(true)}
          >
            Facturación Anual (15% descuento)
          </span>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div className={`pricing-card ${plan.popular ? 'popular' : ''}`} key={index}>
              {plan.popular && <div className="popular-badge">Más Popular</div>}
              
              <div className="pricing-header">
                <h3>{plan.name}</h3>
                <div className="pricing-price">
                  {/* AQUÍ SE MUESTRA EL PRECIO DINÁMICO SEGÚN EL TOGGLE */}
                  <span className="price">{isAnnual ? plan.annualPrice : plan.monthlyPrice}</span>
                  <span className="period">{plan.period}</span>
                </div>
                <p className="pricing-description">{plan.description}</p>
              </div>
              
              <div className="pricing-features">
                <ul>
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className={feature.included ? '' : 'not-included'}>
                      {feature.included ? (
                        <Check size={18} className="feature-icon included" />
                      ) : (
                        <X size={18} className="feature-icon not-included" />
                      )}
                      <span>{feature.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="pricing-cta">
                <Link to="contact" smooth={true} duration={500} className={`btn ${plan.popular ? 'btn-primary' : 'btn-secondary'}`} style={{display: 'block'}}>
                  {plan.cta}
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="pricing-note">
          <p>¿Necesitas una solución personalizada? <Link to="contact" smooth={true} duration={500} style={{cursor: 'pointer'}}>Contáctanos</Link> para obtener un plan a medida.</p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;